"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Standards() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const standards = [{
    label: "CRM Pipeline Integration",
    description: "We architect automated communication flows that ensure every lead is nurtured from initial inquiry to final project sign-off."
  }, {
    label: "FSM Operational Tracking",
    description: "Field Service Management systems configured to provide real-time visibility into crew performance and job site progress."
  }, {
    label: "Automated Bookkeeping",
    description: "Seamless financial infrastructure that syncs your field activity directly to your ledger, eliminating manual data entry errors."
  }, {
    label: "Precision Scheduling",
    description: "Dynamic scheduling engines that optimize your team's time, reducing downtime and maximizing billable hours."
  }, {
    label: "Invoicing Infrastructure",
    description: "Automated billing cycles that trigger upon project milestones, ensuring cash flow remains consistent and predictable."
  }, {
    label: "Systemic Modernization",
    description: "We replace fragmented legacy tools with a unified digital ecosystem designed for scalability and long-term growth."
  }];
  return <section data-section-id="15220" id="industry-standards" className="bg-background text-foreground py-24 md:py-48">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 md:gap-6">
          {}
          <div ref={leftRef} className={`md:col-span-4 transition-all duration-[520ms] ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.7, 0.2, 1)"
        }}>
            <p className="font-mono text-[0.75rem] font-bold uppercase text-primary" style={{
            letterSpacing: "0.2em"
          }}>
              Architectural Standards
            </p>
            <h2 className="font-default mt-6 font-medium text-foreground" style={{
            fontSize: "clamp(2rem, 5vw, 4rem)",
            letterSpacing: "-0.01em",
            lineHeight: "1.1"
          }}>
              How we{" "}
              <em className={`not-italic italic text-primary inline-block transition-opacity duration-200 ${leftVisible ? "opacity-100" : "opacity-0"}`} style={{
              fontStyle: "italic",
              transitionDelay: leftVisible ? "520ms" : "0ms"
            }}>
                integrate
              </em>
              .
            </h2>
            <p className="font-default mt-8 text-foreground/80 max-w-sm" style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
            lineHeight: "1.6"
          }}>
              Our operational discipline is built on precision. We configure backend systems that bridge the gap between physical trade grit and digital efficiency.
            </p>
          </div>

          {}
          <div ref={gridRef} className="md:col-span-8 mt-12 md:mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {standards.map((item, i) => {
              const isLeftCol = i % 2 === 0;
              const isFirstRow = i < 2;
              return <div data-index={i} key={i} className={`group relative pt-8 pb-10 md:pt-10 md:pb-12 transition-all duration-[520ms] ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${isLeftCol ? "md:pr-8" : "md:pl-8"} ${!isFirstRow ? "" : ""}`} style={{
                transitionDelay: gridVisible ? `${i * 60}ms` : "0ms",
                transitionTimingFunction: "cubic-bezier(0.2, 0.7, 0.2, 1)"
              }}>
                    {}
                    <span aria-hidden="true" className="absolute left-0 right-0 top-0 h-[1px] bg-foreground/10 transition-all duration-[240ms] ease-out group-hover:h-[2px] group-hover:bg-primary" />
                    {}
                    {isLeftCol && <span aria-hidden="true" className="hidden md:block absolute right-0 top-0 bottom-0 w-[1px] bg-foreground/10" />}

                    <h3 className="font-default font-semibold text-foreground" style={{
                  fontSize: "clamp(1.25rem, 2vw, 1.75rem)",
                  letterSpacing: "0.05em",
                  lineHeight: "1.3"
                }}>
                      {item.label}
                    </h3>
                    <p className="font-default mt-4 text-foreground/70" style={{
                  fontSize: "1rem",
                  lineHeight: "1.5"
                }}>
                      {item.description}
                    </p>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}